<template>
  <div class="rounded border overflow-hidden">
    <b-table-simple borderless class="mb-0" responsive>
      <b-thead>
        <b-tr>
          <b-th class="align-middle" rowspan="2">No</b-th>
          <b-th class="align-middle" rowspan="2">{{ lodash.upperFirst($t('products.singular')) }}</b-th>
          <b-th class="text-center" colspan="2">Nota Armada</b-th>
          <b-th class="text-center" colspan="2">Estimasi</b-th>
          <b-th class="text-center" colspan="2">Nota Bongkar</b-th>
          <template v-if="!isDraft">
            <b-th class="text-center" colspan="2">Performance</b-th>
            <b-th class="align-middle" rowspan="2">{{ lodash.startCase($t("unloads.quality")) }}</b-th>
            <b-th class="align-middle" rowspan="2">Harga Satuan Bongkar</b-th>
            <b-th class="align-middle" rowspan="2">Jumlah Harga Bongkar</b-th>
          </template>
        </b-tr>
        <b-tr>
          <b-th class="align-top" style="text-align: right">Size</b-th>
          <b-th class="align-top" style="text-align: right">Biomassa</b-th>
          <b-th class="align-top" style="text-align: right">Size</b-th>
          <b-th class="align-top" style="text-align: right">Biomassa</b-th>
          <b-th class="align-top" style="text-align: right">Size</b-th>
          <b-th class="align-top" style="text-align: right">Biomassa</b-th>
          <template v-if="!isDraft">
            <b-th class="align-top" style="text-align: right">Size</b-th>
            <b-th class="align-top" style="text-align: right">Biomassa</b-th>
          </template>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
            v-for="(value, index) in tableItems"
            :key="index"
            :style="{
            '--bs-table-accent-bg': value._bs_table_accent_bg
          }"
        >
          <b-td
              v-if="value._index_rowspan"
              :rowspan="value._index_rowspan"
              class="align-middle" style="vertical-align: top !important;">
            {{ value._index }}
          </b-td>
          <b-td
              v-if="value.trip_rowspan"
              :rowspan="value.trip_rowspan"
              class="align-middle" style="vertical-align: top !important;">
            {{ $t(`unloads.sale_items.products.${value.product_name}`) }}
          </b-td>
          <b-td
              v-if="value.trip_rowspan"
              :rowspan="value.trip_rowspan"
              class="text-end align-middle" style="vertical-align: top !important;">
            {{ $numeral(value.trip_size).format("0,0.[00]") }}
          </b-td>
          <b-td
              v-if="value.trip_rowspan"
              :rowspan="value.trip_rowspan"
              class="text-end align-middle" style="vertical-align: top !important;">
            {{ $numeral(value.trip_quantity).format('0,0.[00]') + ' kg' }}
          </b-td>
          <b-td
              v-if="value.trip_rowspan"
              :rowspan="value.trip_rowspan"
              class="text-end align-middle" style="vertical-align: top !important;">
            {{ $numeral(value.estimated_size).format('0,0.[00]') }}
          </b-td>
          <b-td
              v-if="value.trip_rowspan"
              :rowspan="value.trip_rowspan"
              class="text-end align-middle" style="vertical-align: top !important;">
            {{ $numeral(value.estimated_quantity).format('0,0.[00]') + ' kg' }}
          </b-td>
          <b-td
              v-if="value.sale_rowspan"
              :rowspan="value.sale_rowspan"
              class="text-end" style="vertical-align: top !important;">
            {{ $numeral(value.sale_size).format("0,0.[00]") }}
          </b-td>
          <b-td
              v-if="value.sale_rowspan"
              :rowspan="value.sale_rowspan"
              class="text-end" style="vertical-align: top !important;">
            {{ $numeral(value.sale_quantity).format("0,0.[00]") + " kg" }}
          </b-td>
          <template v-if="!isDraft">
            <b-td class="text-end">
              <div
                  :class="{
                  'badge': true,
                  'text-end': true,
                  ...value.size_performance_class,
                }"
                  style="vertical-align: top !important;"
              >
                {{ $numeral(value.size_performance).format("0,0.[00]%") }}
              </div>
            </b-td>
            <b-td class="text-end" v-if="value.quantity_performance_rowspan" :rowspan="value.quantity_performance_rowspan">
              <div
                  :class="{
                  'badge': true,
                  'text-end': true,
                  ...value.quantity_performance_class
                }"
                  style="vertical-align: top !important;"
              >
                {{ $numeral(value.quantity_performance).format("0,0.[00]%") }}
              </div>
            </b-td>
            <b-td
                v-if="value.sale_rowspan"
                :rowspan="value.sale_rowspan"
                class="text-start" style="vertical-align: top !important;"
            >{{ $t(`qualities.${value.quality}`) }}</b-td>
            <b-td
                v-if="value.sale_rowspan"
                :rowspan="value.sale_rowspan"
                class="text-end" style="vertical-align: top !important;"
            >{{ $numeral(value.unit_price).format("$ 0,0.[00]") }}</b-td>
            <b-td
                v-if="value.sale_rowspan"
                :rowspan="value.sale_rowspan"
                class="text-end" style="vertical-align: top !important;">{{ $numeral(value.total_price).format("$ 0,0.[00]") }}</b-td>
          </template>
        </b-tr>
      </b-tbody>
      <b-tfoot>
        <b-tr>
          <b-th></b-th>
          <b-th class="">Total</b-th>
          <b-th class="text-end" colspan="2">
            {{ $numeral(tripTotalQuantity).format("0,0.[00]") + " kg" }}
          </b-th>
          <b-th class="text-end" colspan="2">
            {{ $numeral(estimatedTotalQuantity).format("0,0.[00]") + " kg" }}
          </b-th>
          <b-th class="text-end" colspan="2">
            {{ $numeral(saleTotalQuantity).format("0,0.[00]") + " kg" }}
          </b-th>
          <template v-if="!isDraft">
            <b-th></b-th>
            <b-th></b-th>
            <b-th></b-th>
            <b-th></b-th>
            <b-th class="text-end">{{ $numeral(saleTotalPrice).format("$ 0,0.[00]") }}</b-th>
          </template>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
  </div>
</template>

<script>
import {round} from "lodash";

export default {
  props: {
    items: Array,
    summaries: Object,
    isDraft: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      sortedItems: this.items.sort((a, b) => a.trip_items[0].id - b.trip_items[0].id),
    }
  },
  computed: {
    tableItems() {
      let vm = this
      let formattedItems = [];
      let formattedIndex = 1;
      let partialTripItemIds = []
      for (let i = 0; i < this.sortedItems.length; i++) {
        let item = this.sortedItems[i];
        let sameTripItemCount = vm.sortedItems.reduce((acc, curr) => acc + curr.trip_items.filter(tripItem => tripItem.id === item.trip_items[0].id).length, 0)
        item.is_merge_item = item.trip_items.length > 1
        item.is_partial_item = sameTripItemCount > 1
        item.is_single_item = !item.is_merge_item && !item.is_partial_item

        if (item.is_merge_item) {
          let totalTripItemQuantity = item.trip_items.reduce((acc, curr) => acc + curr.quantity, 0)
          item.trip_items.forEach((tripItem, index) => {
            let sizePerformance = round((tripItem.size - item.size) / tripItem.size, 4)
            let quantityPerformance = round((item.quantity - totalTripItemQuantity) / totalTripItemQuantity, 4)
            let saleRowspan = index === 0 ? item.trip_items.length : 0
            let estimatedSize = Number((tripItem.size * 0.9).toFixed(2))
            let estimatedQuantity = Number((tripItem.quantity * 1.12).toFixed(2))

            formattedItems.push({
              product_name: tripItem.product_code,
              trip_size: tripItem.size,
              trip_quantity: tripItem.quantity,
              estimated_size: estimatedSize,
              estimated_quantity: estimatedQuantity,
              trip_rowspan: 1,
              sale_size: item.size,
              sale_quantity: item.quantity,
              quality: item.quality,
              unit_price: item.unit_price,
              total_price: item.total_price,
              size_performance: sizePerformance,
              size_performance_class: sizePerformance >= 0.05 ? {'bg-teal-500': true} : {'bg-danger': true},
              quantity_performance: quantityPerformance,
              quantity_performance_class: quantityPerformance >= 0.05 ? {'bg-teal-500': true} : {'bg-danger': true},
              quantity_performance_rowspan: saleRowspan,
              sale_rowspan: saleRowspan,
              _index: formattedIndex,
              _index_rowspan: saleRowspan,
              _bs_table_accent_bg: i % 2 === 0 ? 'white' : '#f8fafc'
            })
            if (saleRowspan > 0) {
              formattedIndex++
            }
          })
        } else if (item.is_partial_item) {
          if (partialTripItemIds.includes(item.trip_items[0].id)) {
            continue
          }
          let tripItem = item.trip_items[0]
          let filteredSaleItems = this.sortedItems.filter(saleItem => saleItem.trip_items[0].id === tripItem.id)
          let totalFilteredSaleItemsQuantity = filteredSaleItems.reduce((acc, curr) => acc + curr.quantity, 0)
          let tripRowspan = filteredSaleItems.length
          let quantityPerformance = round((totalFilteredSaleItemsQuantity - tripItem.quantity) / tripItem.quantity, 4)
          partialTripItemIds.push(tripItem.id)

          filteredSaleItems.forEach((saleItem, index) => {
            let sizePerformance = round((tripItem.size - saleItem.size) / tripItem.size, 4)
            let estimatedSize = Number((tripItem.size * 0.9).toFixed(2))
            let estimatedQuantity = Number((tripItem.quantity * 1.12).toFixed(2))

            formattedItems.push({
              product_name: tripItem.product_code,
              trip_size: tripItem.size,
              trip_quantity: tripItem.quantity,
              estimated_size: estimatedSize,
              estimated_quantity: estimatedQuantity,
              trip_rowspan: index === 0 ? tripRowspan : 0,
              sale_size: saleItem.size,
              sale_quantity: saleItem.quantity,
              quality: saleItem.quality,
              unit_price: saleItem.unit_price,
              total_price: saleItem.total_price,
              size_performance: sizePerformance,
              size_performance_class: sizePerformance >= 0.05 ? {'bg-teal-500': true} : {'bg-danger': true},
              quantity_performance: quantityPerformance,
              quantity_performance_class: quantityPerformance >= 0.05 ? {'bg-teal-500': true} : {'bg-danger': true},
              quantity_performance_rowspan: index === 0 ? tripRowspan : 0,
              sale_rowspan: 1,
              _index: formattedIndex,
              _index_rowspan: index === 0 ? tripRowspan : 0,
              _bs_table_accent_bg: i % 2 === 0 ? 'white' : '#f8fafc'
            })
          })
          formattedIndex++
        } else if (item.is_single_item) {
          let tripItem = item.trip_items[0]
          let sizePerformance = round((tripItem.size - item.size) / tripItem.size, 4)
          let quantityPerformance = round((item.quantity - tripItem.quantity) / tripItem.quantity, 4)
          let estimatedSize = Number((tripItem.size * 0.9).toFixed(2))
          let estimatedQuantity = Number((tripItem.quantity * 1.12).toFixed(2))

          formattedItems.push({
            product_name: tripItem.product_code,
            trip_size: tripItem.size,
            trip_quantity: tripItem.quantity,
            estimated_size: estimatedSize,
            estimated_quantity: estimatedQuantity,
            trip_rowspan: 1,
            sale_size: item.size,
            sale_quantity: item.quantity,
            quality: item.quality,
            unit_price: item.unit_price,
            total_price: item.total_price,
            size_performance: sizePerformance,
            size_performance_class: sizePerformance >= 0.05 ? {'bg-teal-500': true} : {'bg-danger': true},
            quantity_performance: quantityPerformance,
            quantity_performance_class: quantityPerformance >= 0.05 ? {'bg-teal-500': true} : {'bg-danger': true},
            quantity_performance_rowspan: 1,
            sale_rowspan: 1,
            _index: formattedIndex,
            _index_rowspan: 1,
            _bs_table_accent_bg: i % 2 === 0 ? 'white' : '#f8fafc'
          })
          formattedIndex++
        }
      }

      return formattedItems
    },
    tripTotalQuantity() {
      return this.tableItems.reduce((acc, curr) => acc + (curr.trip_rowspan ? curr.trip_quantity : 0), 0)
    },
    estimatedTotalQuantity() {
      return this.tableItems.reduce((acc, curr) => acc + (curr.trip_rowspan ? curr.estimated_quantity : 0), 0)
    },
    saleTotalQuantity() {
      return this.tableItems.reduce((acc, curr) => acc + (curr.sale_rowspan ? curr.sale_quantity : 0), 0)
    },
    saleTotalPrice() {
      return this.tableItems.reduce((acc, curr) => acc + (curr.sale_rowspan ? curr.total_price : 0), 0)
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  thead,
  tfoot {
    tr {
      --bs-table-accent-bg: #f8fafc;
    }
  }

  .table-striped > tbody > tr:nth-of-type(odd) {
    // --bs-table-accent-bg: white;
  }

  .table-striped > tbody > tr:nth-of-type(even) {
    // --bs-table-accent-bg: #f8fafc;
  }
  .badge {
    border-radius: 4px !important;
  }
}
</style>
